import { authConfig } from "../apiConfig";



export const get_project_with_out_pagination = async () => {
    try {
        const response = await authConfig.post(`getAllProjects`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_project_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getAllProjects`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_project_by_id = async (data) => {
    try {
        const response = await authConfig.post(`ProjectviewById`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const project_creation = async (data) => {
    try {
        const response = await authConfig.post(`createProject`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const project_update = async (data) => {
    try {
        const response = await authConfig.post(`updateProject`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const project_deletion = async (data) => {
    try {
        const response = await authConfig.post(``, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};


export const get_project_history_with_out_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getProjectHistory`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};